// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var CaseLocationPurposeType;
(function (CaseLocationPurposeType) {
    CaseLocationPurposeType[CaseLocationPurposeType["UNKNOWN"] = 0] = "UNKNOWN";
    CaseLocationPurposeType[CaseLocationPurposeType["CORPORATEHEADQUARTERS"] = 1] = "CORPORATEHEADQUARTERS";
    CaseLocationPurposeType[CaseLocationPurposeType["SALESOFFICE"] = 2] = "SALESOFFICE";
    CaseLocationPurposeType[CaseLocationPurposeType["RESIDENTIALADDRESS"] = 3] = "RESIDENTIALADDRESS";
    CaseLocationPurposeType[CaseLocationPurposeType["WORKADDRESS"] = 4] = "WORKADDRESS";
    CaseLocationPurposeType[CaseLocationPurposeType["SEASONALADDRESS"] = 5] = "SEASONALADDRESS";
    CaseLocationPurposeType[CaseLocationPurposeType["MAILINGADDRESS"] = 6] = "MAILINGADDRESS";
    CaseLocationPurposeType[CaseLocationPurposeType["BILLINGADDRESS"] = 7] = "BILLINGADDRESS";
    CaseLocationPurposeType[CaseLocationPurposeType["SHIPPINGADDRESS"] = 8] = "SHIPPINGADDRESS";
})(CaseLocationPurposeType || (CaseLocationPurposeType = {}));
//# sourceMappingURL=caseLocationPurposeType.js.map